import React from 'react';
import { CardTheme, IProfileInfo } from '@umu/umu-types';

import { RowCard } from './@components/rowCard/rowCard';
import { ColumnCard } from './@components/columnCard/columnCard';

import './profileShareCard.scss';

interface IProps {
    themId: CardTheme;
    isEnterprise: boolean;
    profileInfo: IProfileInfo;
}

export const ProfileShareCard = (props: IProps) => {
    const { profileInfo, isEnterprise, themId } = props;

    const renderCard = () => {
        if (themId === CardTheme.COLUMN) {
            return <ColumnCard profileInfo={profileInfo} isEnterprise={isEnterprise} />;
        }
        return <RowCard profileInfo={profileInfo} isEnterprise={isEnterprise} />;
    };
    const render = () => {
        return <div className="profile-message-share">{renderCard()}</div>;
    };
    return render();
};
